import { motion } from "framer-motion";

export default function ChapterMarker({ number, label }) {
  return (
    <motion.div
      initial={{ opacity: 0, x: -16 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true, margin: "-20%" }}
      transition={{ duration: 0.6, ease: "easeOut" }}
      className="flex items-center gap-3 mb-6 md:mb-10"
      data-testid={`chapter-marker-${number}`}
    >
      <span className="font-mono text-xl sm:text-2xl text-[#01FFFF] tracking-[0.2em]">
        {number}
      </span>
      <span className="h-px w-10 bg-[#01FFFF]/40" />
      <span className="font-mono text-xs uppercase tracking-[0.35em] text-[#8A9AAB]">
        {label}
      </span>
    </motion.div>
  );
}
